



















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";
import { SupportCustomerFeedback } from "@/http/api/v2/supporter/customerFeedback";
import { CustomerFeedbackDto } from "@/http/dto/customerFeedback";
import { fileUrl } from "@/constants";

const HotelModule = namespace("HotelModule");

@Component
export default class SupportCustomerFeedbackPage extends Vue {
  @HotelModule.State("hotelObjectId") hotelObjectId!: string;
  items: CustomerFeedbackDto[] = [];
  selected: CustomerFeedbackDto | null = null;
  loading = false;
  replying = false;
  page = 1;
  take = 30;
  total = 0;
  status: string | undefined = undefined;
  type: string | undefined = undefined;
  keyword = "";
  reply = "";

  columns = [
    { title: "호텔", key: "hotel", scopedSlots: { customRender: "hotel" }, width: 210 },
    { title: "종류", dataIndex: "type", scopedSlots: { customRender: "type" }, width: 105 },
    { title: "내용", dataIndex: "contents", scopedSlots: { customRender: "contents" } },
    { title: "작성자", dataIndex: "writerName", width: 110 },
    { title: "상태", dataIndex: "status", scopedSlots: { customRender: "status" }, width: 110 },
    { title: "작성일", dataIndex: "createdTime", scopedSlots: { customRender: "createdTime" }, width: 145 },
    { title: "", key: "action", scopedSlots: { customRender: "action" }, width: 100 },
  ];
  get pagination() { return { current: this.page, pageSize: this.take, total: this.total, showSizeChanger: false }; }

  mounted() { this.load(); }
  async load() {
    this.loading = true;
    try {
      const result = await SupportCustomerFeedback.list({ page: this.page, take: this.take, status: this.status, type: this.type, hotelObjectId: this.hotelObjectId || undefined, keyword: this.keyword || undefined });
      this.items = result.items; this.total = result.total;
    } catch { this.$message.error("고객 의견을 불러오지 못했습니다."); }
    finally { this.loading = false; }
  }
  resetAndLoad() { this.page = 1; this.load(); }
  @Watch("hotelObjectId")
  hotelChanged() { this.resetAndLoad(); }
  tableChanged(pagination: any) { this.page = pagination.current; this.load(); }
  async open(row: CustomerFeedbackDto) { try { this.selected = await SupportCustomerFeedback.detail(row.objectId); this.$set(row, "hasUnreadSupportActivity", false); this.$root.$emit("support-feedback-read"); this.reply = ""; } catch { this.$message.error("의견 상세를 불러오지 못했습니다."); } }
  async changeStatus(status: string) { if (!this.selected) return; try { this.selected = await SupportCustomerFeedback.changeStatus(this.selected.objectId, status); this.$root.$emit("support-feedback-read"); await this.load(); } catch { this.$message.error("상태를 변경하지 못했습니다."); } }
  async sendReply() {
    if (!this.selected || !this.reply.trim()) { this.$message.warning("답변 내용을 입력해 주세요."); return; }
    this.replying = true;
    try { this.selected = await SupportCustomerFeedback.reply(this.selected.objectId, this.reply.trim()); this.reply = ""; this.$root.$emit("support-feedback-read"); this.$message.success("답변을 보냈습니다."); await this.load(); }
    catch { this.$message.error("답변을 보내지 못했습니다."); }
    finally { this.replying = false; }
  }
  dateTime(value: string) { return moment(value).format("YYYY.MM.DD HH:mm"); }
  fileUrl(value: string) { return fileUrl(value); }
  typeText(value: string) { return ({ inconvenience: "불편사항", error: "오류 신고", idea: "아이디어", other: "기타" } as any)[value] || value; }
  statusText(value: string) { return ({ received: "접수", reviewing: "검토 중", planned: "반영 예정", answered: "답변 완료" } as any)[value] || value; }
  statusColor(value: string) { return ({ received: "blue", reviewing: "orange", planned: "purple", answered: "green" } as any)[value] || "default"; }
}
